import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiChip: Components<Theme>['MuiChip'] = {
  defaultProps: {
    shape: 'square',
  },
  variants: [
    {
      props: { shape: 'square' },
      style: ({ theme }) => ({ borderRadius: theme.spacing(0.75) }),
    },
    {
      props: { shape: 'rounded' },
      style: { borderRadius: 999 },
    },
    {
      props: { color: 'warning' },
      style: {
        backgroundColor: colors.warning[50],
        borderColor: colors.warning[200],
        color: colors.warning[700],
      },
    },
    {
      props: { color: 'error' },
      style: {
        backgroundColor: colors.red[50],
        borderColor: colors.red[200],
        color: colors.red[700],
      },
    },
    {
      props: { color: 'success' },
      style: {
        backgroundColor: colors.success[50],
        borderColor: colors.success[200],
        color: colors.success[700],
      },
    },
    {
      props: { color: 'info' },
      style: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[200],
        color: colors.blue[700],
      },
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      height: theme.spacing(3),
      fontWeight: 500,

      '& .MuiChip-deleteIcon': {
        fontSize: theme.typography.pxToRem(16),
      },
    }),
    filled: ({ theme }) => ({
      backgroundColor: colors.black[50],
      color: colors.black[950],
      ...theme.applyStyles('dark', {
        backgroundColor: colors.black[850],
        color: colors.black[25],
      }),
    }),
    outlined: ({ theme }) => ({
      borderColor: theme.palette.divider,
    }),
  },
};
